import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import { FixedSizeList } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'

import LinearProgress from '@material-ui/core/LinearProgress'
import Box from '@material-ui/core/Box'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'

import { formatBrl } from '../../utils'
import { editingStart } from '../../store/transactions/transactionsActions'
import { StoreState } from '../../store'

const useStyles = makeStyles((theme) => ({
  list: {
    height: '100%',
  },
  textIncome: {
    color: theme.palette.primary.dark,
  },
  textExpense: {
    color: theme.palette.secondary.dark,
  },
}))

export default function TransactionsList() {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { transactions, selectedIndex, isEditing, isLoading } = useSelector(
    ({ transactionsState }: StoreState) => ({
      transactions: transactionsState.transactions,
      selectedIndex: transactionsState.selectedIndex,
      isEditing: transactionsState.isEditing,
      isLoading: transactionsState.loadingTransactions,
    })
  )

  const onClickItem = (index: number) => () => {
    dispatch(editingStart(index))
  }

  // const getItemSize = (index: number) => {
  //   const transaction = transactions[index]
  //   let size = 60
  //   if (transaction.personName) {
  //     size += transaction.personName.length > 35 ? 45 : 20
  //   }
  //   if (transaction.historic) {
  //     size += 15
  //   }
  //   return size
  // }

  if (isLoading) {
    return <LinearProgress />
  }

  return (
    <List className={classes.list}>
      {!transactions.length ? (
        <Box display="flex" justifyContent="center" color="gray" marginTop={1}>
          <Typography
            variant="caption"
            align="center"
            children="Nenhum registro encontrado"
          />
        </Box>
      ) : (
        <AutoSizer style={{ width: '100%', height: '100%' }}>
          {({ height, width }: any) => (
            <FixedSizeList
              itemData={transactions}
              height={height}
              width={width}
              itemSize={100}
              itemCount={transactions.length}
            >
              {({ index, style }: any) => {
                const {
                  id,
                  categoryName,
                  personName,
                  historic,
                  value,
                  date,
                  status,
                } = transactions[index]

                let newStyle = {
                  ...style,
                  boxShadow: '0px 4px 0px rgba(55, 55, 55, 0.1)',
                }
                return (
                  <ListItem
                    style={newStyle}
                    key={id}
                    selected={isEditing && index === selectedIndex}
                    button
                    onClick={onClickItem(index)}
                  >
                    <Box
                      display="flex"
                      flex={1}
                      justifyContent="space-between"
                      alignItems="top"
                    >
                      <Box>
                        <Typography
                          children={
                            categoryName +
                            (personName ? ` de ${personName}` : '')
                          }
                        />

                        {value >= 0 ? (
                          <ArrowUpwardIcon
                            style={{ color: '#00B9F2', fontSize: 18 }}
                          />
                        ) : (
                          <ArrowDownwardIcon
                            style={{ color: '#ff0000', fontSize: 18 }}
                          />
                        )}

                        <Typography
                          variant="caption"
                          className={
                            classes[value >= 0 ? 'textIncome' : 'textExpense']
                          }
                          children={formatBrl(Math.abs(value))}
                        />

                        {historic ? (
                          <Typography variant="caption">
                            <br />
                            {historic.slice(0, 30)}
                            {historic.length > 30 && '...'}
                          </Typography>
                        ) : (
                          <Typography variant="caption">
                            <br />
                          </Typography>
                        )}
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-end"
                      >
                        <Typography
                          variant="caption"
                          children={moment(date).format('DD/MM/YYYY')}
                        />
                        <Typography variant="caption">
                          <b>{status}</b>
                        </Typography>
                      </Box>
                    </Box>
                  </ListItem>
                )
              }}
            </FixedSizeList>
          )}
        </AutoSizer>
      )}
    </List>
  )
}

//     transactions.map((transaction, i) => (
//       <List>
//         <ListItem
//           key={transaction.id}
//           selected={isEditing && i === selectedIndex}
//           button
//           onClick={onClickItem(i)}
//         >
//           <Box display="flex" flex={1} justifyContent="space-between">
//             <Box>
//               <Typography
//                 children={
//                   transaction.categoryName +
//                   (transaction.personName
//                     ? ` de ${transaction.personName}`
//                     : '')
//                 }
//               />
//               {transaction.historic && (
//                 <Typography variant="caption">
//                   {transaction.historic}
//                   <br />
//                 </Typography>
//               )}

//               {transaction.value >= 0 ? (
//                 <ArrowUpwardIcon
//                   style={{ color: '#00B9F2', fontSize: 16 }}
//                 />
//               ) : (
//                 <ArrowDownwardIcon
//                   style={{ color: '#ff0000', fontSize: 16 }}
//                 />
//               )}
//               <Typography
//                 variant="caption"
//                 className={
//                   classes[
//                     transaction.value >= 0 ? 'textIncome' : 'textExpense'
//                   ]
//                 }
//                 children={formatBrl(Math.abs(transaction.value))}
//               />
//             </Box>
//             <Box
//               display="flex"
//               flexDirection="column"
//               alignItems="flex-end"
//             >
//               <Typography
//                 variant="caption"
//                 children={moment(transaction.date).format('DD/MM/YYYY')}
//               />
//               <Typography variant="caption">
//                 <b>{transaction.status}</b>
//               </Typography>
//             </Box>
//           </Box>
//         </ListItem>
//         <hr className="ml-4" />
//       </List>
//     ))
//   )}
